import React from "react";
import ReactDom from "react-dom";
import NavBar from "./NavBar";
const navDest = document.getElementById("navRoot");

const NavPortal = (props) => {
  return ReactDom.createPortal(<NavBar />, navDest);
};

export default NavPortal;
